"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maybeRenamedMilestone = exports.milestoneNames = void 0;
exports.milestoneNames = [
    'Terraformer',
    'Mayor',
    'Gardener',
    'Planner',
    'Builder',
    'Generalist',
    'Specialist',
    'Ecologist',
    'Tycoon',
    'Legend',
    'Diversifier',
    'Tactician',
    'Polar Explorer',
    'Energizer',
    'Rim Settler',
    'Hoverlord',
    'Networker',
    'One Giant Step',
    'Lunarchitect',
    'Colonizer',
    'Minimalist',
    'Terran',
    'Tropicalist',
    'Economizer',
    'Pioneer',
    'Land Specialist',
    'Martian',
    'T. Collector',
    'Firestarter',
    'Terra Pioneer',
    'Spacefarer',
    'Gambler',
    'Architect',
    'Coastguard',
    'C. Forester',
    'V. Electrician',
    'Smith',
    'Tradesman',
    'Irrigator',
    'Capitalist',
    'Agronomist',
    'Engineer',
    'V. Spacefarer',
    'Geologist',
    'Farmer',
    'Tunneler',
    'Risktaker',
    'Purifier',
    'Builder7',
    'Forester',
    'Fundraiser',
    'Hydrologist',
    'Landshaper',
    'Legend4',
    'Lobbyist',
    'Metallurgist',
    'Philantropist',
    'Pioneer4',
    'Planetologist',
    'Producer',
    'Researcher',
    'Spacefarer4',
    'Sponsor',
    'Tactician4',
    'Terraformer29',
    'Terran5',
    'Thawer',
    'Trader',
    'Tycoon10',
];
const MILESTONE_RENAMES = new Map([]);
function maybeRenamedMilestone(name) {
    const renamed = MILESTONE_RENAMES.get(name);
    return renamed ?? name;
}
exports.maybeRenamedMilestone = maybeRenamedMilestone;
